/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Display_Settings_Success_MessageInputs */

const en_iframe_remote_display_settings_success_message = /** @type {(inputs: Iframe_Remote_Display_Settings_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display settings updated successfully`)
};

const fr_iframe_remote_display_settings_success_message = /** @type {(inputs: Iframe_Remote_Display_Settings_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parametres d'affichage mis a jour avec succes`)
};

const de_iframe_remote_display_settings_success_message = /** @type {(inputs: Iframe_Remote_Display_Settings_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigeeinstellungen erfolgreich aktualisiert`)
};

const it_iframe_remote_display_settings_success_message = /** @type {(inputs: Iframe_Remote_Display_Settings_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di visualizzazione aggiornate correttamente`)
};

const ru_iframe_remote_display_settings_success_message = /** @type {(inputs: Iframe_Remote_Display_Settings_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки дисплея успешно обновлены.`)
};

const es_iframe_remote_display_settings_success_message = /** @type {(inputs: Iframe_Remote_Display_Settings_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La configuración de pantalla se actualizó correctamente`)
};

const zh_cn2_iframe_remote_display_settings_success_message = /** @type {(inputs: Iframe_Remote_Display_Settings_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示设置已成功更新`)
};

const ja_iframe_remote_display_settings_success_message = /** @type {(inputs: Iframe_Remote_Display_Settings_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示設定が正常に更新されました`)
};

const hi_iframe_remote_display_settings_success_message = /** @type {(inputs: Iframe_Remote_Display_Settings_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डिस्प्ले सेटिंग्स सफलतापूर्वक अपडेट हो गईं`)
};

const pt_pt2_iframe_remote_display_settings_success_message = /** @type {(inputs: Iframe_Remote_Display_Settings_Success_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de exibição atualizadas com sucesso`)
};

/**
* | output |
* | --- |
* | "Display settings updated successfully" |
*
* @param {Iframe_Remote_Display_Settings_Success_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_display_settings_success_message = /** @type {((inputs?: Iframe_Remote_Display_Settings_Success_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Display_Settings_Success_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_display_settings_success_message(inputs)
	if (locale === "de") return de_iframe_remote_display_settings_success_message(inputs)
	if (locale === "it") return it_iframe_remote_display_settings_success_message(inputs)
	if (locale === "ru") return ru_iframe_remote_display_settings_success_message(inputs)
	if (locale === "es") return es_iframe_remote_display_settings_success_message(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_display_settings_success_message(inputs)
	if (locale === "ja") return ja_iframe_remote_display_settings_success_message(inputs)
	if (locale === "hi") return hi_iframe_remote_display_settings_success_message(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_display_settings_success_message(inputs)
	return en_iframe_remote_display_settings_success_message(inputs)
});